import { format } from 'date-fns';
import React from 'react';
import styled from 'styled-components';
import { useObserverReturningStore } from '../../../CodesThatsGottaGoSomewhereElse';
import { Rect } from '../../../platform/geom/Rect';
import { Colors } from '../../../ui';
import { Camera } from '../../canvas/Camera';
import { useEditorSessionObserver } from '../../canvas/EditorSession';
import { RelativeTo } from '../../canvas/entities/Physical';
import { Selection } from '../../canvas/Selection';
import { useComponentObserver } from '../../canvas/visualization/ComponentObserver';
import { useResolve } from '../../Container';
import { RoadmapCard } from './RoadmapCard';
import { RoadmapCardEndDate, RoadmapCardStartDate, RoadmapCardTargetDate } from './RoadmapCardAssocs';

const MarkerMount = styled.div<{ mode: 'ends' | 'inner' }>`
    position: absolute;
    left: 0;
    /* top: ${p => p.mode === 'ends' ? '-.25rem' : '0'}; */
    top: 0;
    background: ${Colors.primaryLight};
    width: .125rem;
    height: ${p => p.mode === 'ends' ? '2rem' : '3.5rem'};
    transform: translate(-.0625rem, -100%);
    pointer-events: none;
`;

const Mount = styled.div`
    position: absolute;
`;

const Frame = styled.div<{ mode: 'fill' | 'stroke' }>`
    position: absolute;
    top: 0;
    left: 0;
    padding: 0.125rem 0.375rem;
    transform: translateX(-50%);
    background: ${p => p.mode === 'fill' ? Colors.primaryLight : 'white'};
    color: ${p => p.mode === 'fill' ? 'white' : Colors.primaryLight};
    font-size: 0.75rem;
    border-radius: 0.25rem;
    text-wrap: nowrap;
`;

export const RoadmapCardDateMarkerWidget = () => {

    const camera = useObserverReturningStore(useResolve(Camera));
    const selection = useEditorSessionObserver(Selection);
    const subject = selection.first()?.as(RoadmapCard);
    useComponentObserver(subject);

    if (!subject) return null;
    if (selection.size !== 1) return null;

    const startDate = RoadmapCardStartDate.get(subject);
    const endDate = RoadmapCardEndDate.get(subject);
    const targetDate = RoadmapCardTargetDate.get(subject);
    if (!startDate || !endDate) return null;

    const viewFrame = Rect.fromPoints(camera.toView(subject.bounds(RelativeTo.Model)));
    const markerPos = subject.marker < 0 ? viewFrame.width : viewFrame.width * (subject.marker / subject.width);

    const startPos = 0;
    const endPos = subject.punctuality === 'early' ? markerPos : viewFrame.width;
    const targetPos =
        (subject.punctuality === 'early' ? viewFrame.width : null) ??
        (subject.punctuality === 'late' ? markerPos : null);

    const bump = !!targetPos && (Math.max(endPos, targetPos) - Math.min(endPos, targetPos)) < 85;

    return <Mount style={{ ...viewFrame.toCSS() }}>
        <MarkerMount mode="ends" style={{ left: `${startPos}px` }}>
            <Frame mode="fill">
                {format(startDate, 'dd MMM yyyy')}
            </Frame>
        </MarkerMount>
        <MarkerMount mode="ends" style={{ left: `${endPos}px` }}>
            <Frame mode="fill">
                {format(endDate, 'dd MMM yyyy')}
            </Frame>
        </MarkerMount>
        {!!targetPos &&
            <MarkerMount mode="inner" style={{ left: `${targetPos}px`, height: bump ? '3.5rem' : '2rem' }}>
                <Frame mode="stroke">
                    <span style={{ textDecoration: 'line-through' }}>
                        {format(targetDate, 'dd MMM yyyy')}
                    </span>
                </Frame>
            </MarkerMount>
        }

    </Mount >
};
